import React from 'react';
import PropTypes from 'prop-types';
import { LocalizedMessage, LocalizedPrice } from 'intl/LocalizedComponents';
// Models
import { displayAmount } from 'models/cpm/priceRule';
// Custom
import { cpmPurchaseShape } from 'constants/PropTypesShapes';
import StripePaymentForm from 'components/payment/StripePaymentForm';

const PurchasePayment = ({ purchase, options, onSuccess }) => {
  const { currency } = purchase.priceRule;
  const { withPaymentMethods, needsOnDemandCustomerInformation } = options;
  const totalAmountInclTax = displayAmount(purchase.totalAmountInclTax);

  const ConfirmButtonLabel = (
    <LocalizedMessage
      id="button.payNow"
      values={{ amount: <LocalizedPrice currency={currency} value={totalAmountInclTax} /> }}
    />
  );

  return (
    <StripePaymentForm
      purchase={purchase}
      withPaymentMethods={withPaymentMethods}
      needsOnDemandCustomerInformation={needsOnDemandCustomerInformation}
      confirmButtonLabel={ConfirmButtonLabel}
      onSuccess={onSuccess}
    />
  );
};

PurchasePayment.propTypes = {
  purchase: cpmPurchaseShape.isRequired,
  options: PropTypes.shape({
    operationSuccess: PropTypes.string.isRequired,
    successURI: PropTypes.string.isRequired,
    withPaymentMethods: PropTypes.bool.isRequired,
    needsOnDemandCustomerInformation: PropTypes.bool,
  }).isRequired,
  onSuccess: PropTypes.func.isRequired,
};

module.exports = PurchasePayment;



// WEBPACK FOOTER //
// ./routes/purchase/assets/PurchasePayment.js